// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Restyle CKEditor's frame so it matches .cui-control */
.cre-wrap {
  width: 100%;
  min-width: 0;
  border: var(--cui-border-width) solid var(--cui-border);
  border-radius: var(--cui-radius);
  background: var(--cui-bg);
  overflow: hidden;
  transition: border-color var(--cui-transition), box-shadow var(--cui-transition);
}

.cre-wrap:hover:not(.cre-error) {
  border-color: var(--cui-border-hover);
}

.cre-wrap:focus-within {
  border-color: var(--cui-primary);
  box-shadow: 0 0 0 3px var(--cui-primary-ring);
}

/* Error: red border + red ring */
.cre-error,
.cre-error:hover,
.cre-error:focus-within {
  border-color: var(--cui-danger);
}

.cre-error:focus-within {
  box-shadow: 0 0 0 3px var(--cui-danger-ring);
}

/* Remove CKEditor's own borders — the wrapper draws the only one */
.cre-wrap .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.cre-wrap .ck.ck-toolbar {
  border: 0 !important;
  border-bottom: 1px solid var(--cui-border-soft) !important;
  border-radius: 0 !important;
  background: var(--cui-bg-subtle) !important;
}

.cre-wrap .ck.ck-editor__main > .ck-editor__editable,
.cre-wrap .ck.ck-editor__main > .ck-editor__editable.ck-focused {
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  font-size: var(--cui-font-size);
  color: var(--cui-text);
}

/* Toolbar wraps onto more lines on small screens instead of overflowing */
.cre-wrap .ck.ck-toolbar > .ck-toolbar__items {
  flex-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomRichTextEditor/CustomRichTextEditor.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,WAAW;EACX,YAAY;EACZ,uDAAuD;EACvD,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA,iCAAiC;AACjC;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,mEAAmE;AACnE;;EAEE,oBAAoB;EACpB,0DAA0D;EAC1D,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;EAEE,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA,0EAA0E;AAC1E;EACE,eAAe;AACjB","sourcesContent":["/* Restyle CKEditor's frame so it matches .cui-control */\n.cre-wrap {\n  width: 100%;\n  min-width: 0;\n  border: var(--cui-border-width) solid var(--cui-border);\n  border-radius: var(--cui-radius);\n  background: var(--cui-bg);\n  overflow: hidden;\n  transition: border-color var(--cui-transition), box-shadow var(--cui-transition);\n}\n\n.cre-wrap:hover:not(.cre-error) {\n  border-color: var(--cui-border-hover);\n}\n\n.cre-wrap:focus-within {\n  border-color: var(--cui-primary);\n  box-shadow: 0 0 0 3px var(--cui-primary-ring);\n}\n\n/* Error: red border + red ring */\n.cre-error,\n.cre-error:hover,\n.cre-error:focus-within {\n  border-color: var(--cui-danger);\n}\n\n.cre-error:focus-within {\n  box-shadow: 0 0 0 3px var(--cui-danger-ring);\n}\n\n/* Remove CKEditor's own borders — the wrapper draws the only one */\n.cre-wrap .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,\n.cre-wrap .ck.ck-toolbar {\n  border: 0 !important;\n  border-bottom: 1px solid var(--cui-border-soft) !important;\n  border-radius: 0 !important;\n  background: var(--cui-bg-subtle) !important;\n}\n\n.cre-wrap .ck.ck-editor__main > .ck-editor__editable,\n.cre-wrap .ck.ck-editor__main > .ck-editor__editable.ck-focused {\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  font-size: var(--cui-font-size);\n  color: var(--cui-text);\n}\n\n/* Toolbar wraps onto more lines on small screens instead of overflowing */\n.cre-wrap .ck.ck-toolbar > .ck-toolbar__items {\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
